import { get } from "@crunchit/http-client";
import { IModuleDto } from "@crunchit/types";
import { getToken, getEnvironment } from "utils/helpers/service";

const api = process.env.REACT_APP_MODULE_URI || `module.${getEnvironment()}crunchy.ninja/api`;

const ModuleService = {
  getModules: async () => {
    return get<IModuleDto[]>(`${api}/module/modules`, getToken());
  },
};

export default ModuleService;
